import { v4 as uuid } from 'uuid';

export function createRowId(): string {
  return uuid();
}
